<template>
    <div class="card card-body">
        <!--begin::Login Sign up form-->
        <div class="login-signup">
            <div class="mb-20">
                <h3>Sign Up</h3>
                <div class="text-muted font-weight-bold">
                    Enter your details to create your account
                </div>
            </div>
            <!-- Error management -->
            <CustomAlerts :errors="errors"></CustomAlerts>
            <!-- Start form -->
            <form class="form" @submit.prevent="doRegister">
                <div class="form-group mb-5">
                    <input
                        class="form-control h-auto form-control-solid py-4 px-8"
                        type="text"
                        placeholder="Username"
                        v-model="form.username"
                    />
                </div>
                <div class="form-group mb-5">
                    <input
                        class="form-control h-auto form-control-solid py-4 px-8"
                        type="text"
                        placeholder="Email"
                        name="email"
                        autocomplete="off"
                        v-model="form.email"
                    />
                </div>
                <div class="form-group mb-5">
                    <input
                        class="form-control h-auto form-control-solid py-4 px-8"
                        type="password"
                        placeholder="Password"
                        name="password"
                        v-model="form.password"
                    />
                </div>
                <div class="form-group mb-5">
                    <input
                        class="form-control h-auto form-control-solid py-4 px-8"
                        type="password"
                        placeholder="Confirm Password"
                        name="rpassword"
                        v-model="form.confirmPassword"
                    />
                </div>
                <div class="form-group mb-5 text-left">
                    <label class="checkbox m-0">
                        <input type="checkbox" name="agree" v-model="form.checkbox" />
                        <span class="mr-2"></span>
                        I agree to the
                        <router-link to="/privacy" class="font-weight-bold ml-1">
                            terms and conditions </router-link
                        >.
                    </label>
                    <div class="form-text text-muted text-center"></div>
                </div>
                <div class="form-group d-flex flex-wrap flex-center mt-10">
                    <button
                        class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2"
                        type="submit"
                        :disabled="formIsLoading"
                        :class="
                            formIsLoading ? 'spinner spinner-darker-danger spinner-left mr-3' : ''
                        "
                    >
                        Sign Up
                    </button>
                    <router-link
                        to="/login"
                        class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2"
                        >Cancel</router-link
                    >
                </div>
            </form>
        </div>
        <!--end::Login Sign up form-->
    </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import cookies from "js-cookie";

export default {
    name: "register2",
    components: {
        CustomAlerts,
    },
    data() {
        return {
            // Errors
            errors: [],

            // Form
            form: {
                username: "",
                password: "",
                email: "",
                confirmPassword: "",
                checkbox: false,
                referralby: "",
            },

            // Loaders
            formIsLoading: false,
        };
    },
    methods: {
        doRegister() {
            // Set preloader
            this.formIsLoading = true;

            // Reset errors
            this.errors = [];

            // Check if we have a cookie
            this.form.referralby = cookies.get("JS-referral");

            // Perform post
            axios
                .post("auth/register", {
                    username: this.form.username,
                    email: this.form.email,
                    password: this.form.password,
                    confirmPassword: this.form.confirmPassword,
                    checkbox: this.form.checkbox,
                    referralby: this.form.referralby,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Handle messages coming through
                    if (data.messages.length > 0) {
                        data.messages.forEach((currentItem) => {
                            this.errors.push({
                                type: currentItem.type,
                                message: currentItem.message,
                            });
                        });
                    }
                    // Check status
                    if (data.status == "OK") {
                        // Commit to store
                        this.$store.dispatch("auth/me");

                        // Redirect to dashboard
                        setTimeout(() => {
                            this.$router.push({ name: "dashboard" }).catch(() => {});
                        }, 4000);
                    } else {
                        // Close preloader if the status ISN'T ok. We want to redirect the user in that case anyway.
                        this.formIsLoading = false;
                    }
                })
                .catch((error) => {
                    this.errors.push({
                        type: "danger",
                        message:
                            "There was an issue requesting data from the API. Please refresh the page and try again.",
                    });
                    console.log(error);
                    // Close preloader
                    this.formIsLoading = false;
                })
                .finally(() => {
                    // Do nothing
                });
        },

        handleReferral() {
            // Handle params
            var params = {};
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    params[item.split("=")[0]] = item.split("=")[1];
                });

            // Check if we have a referral
            if (params.referral) {
                // Reset URL
                window.history.pushState({}, document.title, "/register");

                // Set cookie
                cookies.set("JS-referral", params.referral, {
                    domain: ".hashtastic.eu",
                    expires: 365,
                });
            }
        },
    },

    mounted() {
        this.handleReferral();
    },
};
</script>
